import { render, staticRenderFns } from "./TsOffcanvas.vue?vue&type=template&id=093bb8c2"
import script from "./TsOffcanvas.vue?vue&type=script&lang=ts"
export * from "./TsOffcanvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports